import { TFunction } from 'react-i18next';
import { Column } from 'react-table';
import OverflowTooltip from '../../OverflowTooltip/OverflowTooltip';
import EmptyRowContent from '../../DataTable/EmptyRowContent';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TwoLineCell from '../../Calls/TwoLineCell';
import DateTimeCell from '../../Calls/DateTimeCell';

export interface DidUsageTableRowInterface {
    id: string;
    accountId?: string;
    didNumber: string;
    description?: string;
    start?: string;
    end?: string;
    chargedAmount?: number;
}

export const generateColumns = (
    t: TFunction<string>,
    currency = 'USD',
    userDateTimeFormat?: string,
): Column<DidUsageTableRowInterface>[] => {
    return [
        {
            Header: t<string>('screens:billing.accountID'),
            accessor: 'accountId',
            width: 1,
            Cell: function Cell(params) {
                const text = params.row.original.accountId;

                return (
                    <OverflowTooltip
                        tooltip={text}
                        text={text}
                        dataQa={'account-id-text'}
                        copy={false}
                    />
                );
            },
        },
        {
            Header: t<string>('common:description'),
            accessor: 'didNumber',
            width: 2,
            Cell: function Cell(params) {
                return (
                    <TwoLineCell
                        headerText={params.row.original.didNumber}
                        descriptionText={params.row.original.description}
                    />
                );
            },
        },
        {
            Header: t<string>('common:startDate'),
            accessor: 'start',
            width: 1,
            Cell: function Cell(params) {
                return params.row.original.start ? (
                    <DateTimeCell
                        time={params.row.original.start as string}
                        customDateFormat={userDateTimeFormat}
                    />
                ) : (
                    <EmptyRowContent />
                );
            },
        },
        {
            Header: t<string>('common:endDate'),
            accessor: 'end',
            width: 1,
            Cell: function Cell(params) {
                return params.row.original.end ? (
                    <DateTimeCell
                        time={params.row.original.end as string}
                        customDateFormat={userDateTimeFormat}
                    />
                ) : (
                    <EmptyRowContent />
                );
            },
        },
        {
            Header: t<string>('screens:billing.chargedWithCurrency', {
                currency: currency,
            }),
            width: 0.5,
            accessor: 'chargedAmount',
            Cell: function Cell(params) {
                return params.row.original.chargedAmount
                    ? params.row.original.chargedAmount.toFixed(2)
                    : Number(0).toFixed(2);
            },
        },
    ];
};

export const useStyles = makeStyles(() => ({
    header: {
        '& th:nth-child(5)': {
            display: ' flex',
            justifyContent: 'end',
        },
    },

    tableContent: {
        '& td': {
            alignItems: 'center !important',
        },
        '& td:nth-child(5)': {
            display: 'flex',
            justifyContent: 'end',
        },
    },
}));
